import { createSlice, createAction } from "@reduxjs/toolkit";
import {
	FormRequest,
	FormRequestQueryParams,
} from "features/webapp/form-request/type";
import { RootState } from "store/store";

interface InvestmentState {
	investmentList: Array<FormRequest>;
	investmentTotal: number;
}

const initialState: InvestmentState = {
	investmentList: [],
	investmentTotal: 0,
};

export const investment = createSlice({
	name: "investment",
	initialState,
	reducers: {
		setListInvestment: (state, action) => {
			state.investmentList = action.payload.data;
			state.investmentTotal = action.payload.total;
		},
	},
});

export const selectInvestmentList = (state: RootState) =>
	state.investment.investmentList;
export const selectInvestmentTotal = (state: RootState) =>
	state.investment.investmentTotal;

export const { setListInvestment } = investment.actions;

export interface GetListInvestmentAsyncPayload {
	query: FormRequestQueryParams;
	callback?: () => void;
}

export const getListInvestmentAsync = createAction(
	"investment/getListInvestmentAsync",
	(payload: GetListInvestmentAsyncPayload) => ({
		payload: payload || {},
	}),
);

export default investment.reducer;
